import { selectBestMatchingColor } from '@common/hooks/useEquivalentProductMatching/utils/selectBestMatchingColor';
import { ColorModel } from '@common/models';
import { createSelectedHook } from '@core/utils/createSelectedHook';
import { selectRestorableColor, selectSelectedColor } from '@redux/slices/colorSlice';

import useColors from './useColors';

const useColorsData = (): ColorModel[] => {
    const { colors } = useColors();
    return colors;
};

export const useSelectedColor = createSelectedHook({
    selector: selectSelectedColor,
    restorableSelector: selectRestorableColor,
    apiQueryHook: useColorsData,
    selectRestoredValue: ({ apiHookResponse, restorableValue, selectedValue }) =>
        selectedValue || apiHookResponse.find((color) => color.productId === restorableValue?.productId),
    shouldReturnDefault: ({ selectedValue, apiHookResponse }) =>
        !selectedValue || !apiHookResponse.find((color) => color.productId === selectedValue?.productId),
    selectDefaultValue: ({ apiHookResponse, selectedValue }) => selectBestMatchingColor(selectedValue, apiHookResponse), // This finds the best match OR the default
});
